import {Helmet} from '@dr.pogodin/react-helmet';
import {Tabs} from 'platform/components';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {AccountingMatrixDatagridM2Centres} from './(sections)/AccountingMatrixDatagridM2Centres/AccountingMatrixDatagridM2Centres';
import {AccountingMatrixDatagridM13Vat} from './(sections)/AccountingMatrixDatagridM13Vat/AccountingMatrixDatagridM13Vat';
import {AccountingMatrixDatagridM101Cash} from './(sections)/AccountingMatrixDatagridM101Cash/AccountingMatrixDatagridM101Cash';
import {AccountingMatrixDatagridM201Invoices} from './(sections)/AccountingMatrixDatagridM201Invoices/AccountingMatrixDatagridM201Invoices';
import {AccountingMatrixDatagridM202Headers} from './(sections)/AccountingMatrixDatagridM202Headers/AccountingMatrixDatagridM202Headers';
import {AccountingMatrixDatagridM205Items} from './(sections)/AccountingMatrixDatagridM205Items/AccountingMatrixDatagridM205Items';
import {AccountingMatrixDatagridOperationItems} from './(sections)/AccountingMatrixDatagridOperationItems/AccountingMatrixDatagridOperationItems';
import {MatrixList} from './(sections)/MatrixList/MatrixList';

export function MatrixManagement() {
  const title = i18n.t('page.accounting.labels.accountingMatrixManagement');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        data-testid={testIds.settings.accountingMatrixManagement('header')}
        header={{
          title,
        }}
      >
        <Tabs
          data-testid={testIds.settings.accountingMatrixManagement('tabs')}
          isLazy
          lazyBehavior="keepMounted"
          tabs={[
            {
              id: 'metadaMatrices',
              title: i18n.t('page.accountingSettings.labels.metada'),
              content: <MatrixList category="matrices-config-from-metada-to-google" />,
            },
            {
              id: 'googleSheetsMatrices',
              title: i18n.t('page.accountingSettings.labels.googleSheets'),
              content: <MatrixList category="matrices-config-from-google-to-metada" />,
            },
            {
              id: 'm101-cash',
              title: i18n.t('page.accounting.labels.accountingMatrixDatagridsCash'),
              content: <AccountingMatrixDatagridM101Cash />,
            },
            {
              id: 'm13-vat',
              title: i18n.t('page.accounting.labels.accountingMatrixDatagridsVat'),
              content: <AccountingMatrixDatagridM13Vat />,
            },
            {
              id: 'm2-centres',
              title: i18n.t('page.accounting.labels.accountingMatrixDatagridsCentres'),
              content: <AccountingMatrixDatagridM2Centres />,
            },
            {
              id: 'm201-invoices',
              title: i18n.t('page.accounting.labels.accountingMatrixDatagridsInvoices'),
              content: <AccountingMatrixDatagridM201Invoices />,
            },
            {
              id: 'm202-headers',
              title: i18n.t('page.accounting.labels.accountingMatrixDatagridsHeaders'),
              content: <AccountingMatrixDatagridM202Headers />,
            },
            {
              id: 'm205-items',
              title: i18n.t('page.accounting.labels.accountingMatrixDatagridsItems'),
              content: <AccountingMatrixDatagridM205Items />,
            },
            {
              id: 'operation-items',
              title: i18n.t('page.accounting.labels.accountingMatrixDatagridsOperationItems'),
              content: <AccountingMatrixDatagridOperationItems />,
            },
          ]}
        />
      </SettingsTemplate>
    </>
  );
}
